import { categoryEmoji } from '@lista/app-core';
import type { SVGProps } from 'react';

/** Stroke icons drawn on a 24px grid. Directional ones get `mirror-rtl` so they flip in Arabic. */
const PATHS = {
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  close: 'M6 6l12 12M18 6L6 18',
  back: 'M15 5l-7 7 7 7',
  chevron: 'M9 5l7 7-7 7',
  more: 'M12 6.5h.01M12 12h.01M12 17.5h.01',
  search: 'M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM20 20l-4.8-4.8',
  star: 'M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.8z',
  share:
    'M16 8a3 3 0 100-6 3 3 0 000 6zM8 15a3 3 0 100-6 3 3 0 000 6zM16 22a3 3 0 100-6 3 3 0 000 6zM10.6 13.5l2.8 1.6M13.4 6.9l-2.8 1.6',
  pdf: 'M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8zM14 3v5h5M12 12v6M9.5 15.5L12 18l2.5-2.5',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
  copy: 'M9 9h10v11H9zM5 15V4h10',
  pin: 'M9 4h6l-1 6 3 3v2H7v-2l3-3zM12 15v6',
  archive: 'M3.5 5h17v4h-17zM5 9v10h14V9M10 13h4',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6',
  users:
    'M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2.5 20c.6-3.4 3.2-5.5 6.5-5.5s5.9 2.1 6.5 5.5M16 4.3a3.5 3.5 0 010 6.4M18 14.8c1.9.8 3.1 2.6 3.5 5.2',
  lists: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  grid: 'M6 4.5h3A1.5 1.5 0 0110.5 6v3A1.5 1.5 0 019 10.5H6A1.5 1.5 0 014.5 9V6A1.5 1.5 0 016 4.5zM15 4.5h3A1.5 1.5 0 0119.5 6v3a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 0113.5 9V6A1.5 1.5 0 0115 4.5zM6 13.5h3a1.5 1.5 0 011.5 1.5v3A1.5 1.5 0 019 19.5H6A1.5 1.5 0 014.5 18v-3A1.5 1.5 0 016 13.5zM15 13.5h3a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 01-1.5-1.5v-3a1.5 1.5 0 011.5-1.5z',
  settings:
    'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 21c.8-4 4-6.5 8-6.5s7.2 2.5 8 6.5',
  logout: 'M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3M10 17l-5-5 5-5M5 12h11',
  note: 'M5 5h14M5 10h14M5 15h9',
  offline:
    'M3 3l18 18M8.5 16.5a5 5 0 017 0M5 12.6a10 10 0 015.2-2.8M19 12.6a10 10 0 00-2.3-1.6M2 8.8A15 15 0 016.6 6M22 8.8A15 15 0 0011.2 4M12 20h.01',
  refresh: 'M20 11a8 8 0 10-2.3 5.7M20 5v6h-6',
  install: 'M12 4v11M7.5 10.5L12 15l4.5-4.5M5 20h14',
  open: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5',
  grip: 'M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01',
  bell: 'M6 9a6 6 0 1112 0c0 5 2 6.5 2 6.5H4S6 14 6 9zM10 19a2 2 0 004 0',
  sparkles:
    'M11 3l1.9 5.6L18.5 10.5l-5.6 1.9L11 18l-1.9-5.6L3.5 10.5l5.6-1.9zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z',
  meals:
    'M12 6.5C10 5 7.5 4.5 3.5 4.5v13c4 0 6.5.5 8.5 2 2-1.5 4.5-2 8.5-2v-13c-4 0-6.5.5-8.5 2zM12 6.5v13',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  sun: 'M12 16a4 4 0 100-8 4 4 0 000 8zM12 2.5v2M12 19.5v2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M2.5 12h2M19.5 12h2M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4',
  moon: 'M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z',
  camera: 'M4 8h3.2l1.8-2.5h6l1.8 2.5H20v11H4zM12 16.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z',
  image: 'M4 5h16v14H4zM4 16l4.5-4.5 3.5 3.5 2.5-2.5L20 17M15.5 9.5h.01',
  cart: 'M3 4h2.5l2.2 10.5a1.5 1.5 0 001.5 1.2h7.9a1.5 1.5 0 001.5-1.1L20.5 8H6.4M10 20h.01M17 20h.01',
  shield: 'M12 3l7 3v5c0 4.5-3 8.4-7 10-4-1.6-7-5.5-7-10V6zM9 12l2 2 4-4',
  expand: 'M6 9l6 6 6-6',
} as const;

export type IconName = keyof typeof PATHS;

const DIRECTIONAL: ReadonlySet<IconName> = new Set(['back', 'chevron', 'logout']);

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
  filled?: boolean;
}

export function Icon({ name, size = 20, filled = false, className, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={name === 'more' || name === 'grip' ? 3 : name === 'grid' ? 1.5 : 1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={
        [DIRECTIONAL.has(name) ? 'mirror-rtl' : '', className ?? ''].join(' ').trim() || undefined
      }
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

export function CategoryGlyph({ icon, size = 22 }: { icon: string | undefined; size?: number }) {
  return (
    <span aria-hidden="true" style={{ fontSize: size, lineHeight: 1 }}>
      {categoryEmoji(icon)}
    </span>
  );
}
